export default {
  setUsuario(state, usuario) {
    state.usuario = usuario;
  },
  setModulos(state, modulos) {
    state.modulos = modulos;
  },
  setAnioProcesoAdmision(state, anioProcesoAdmision) {
    state.anioProcesoAdmision = anioProcesoAdmision;
  },
  setProceso(state, proceso) {
    state.proceso = proceso;
  },
  setTiposPesd(state, update) {
    state.tiposPesd = update;
  },
};
